import { render, staticRenderFns } from "./ProlongDialog.vue?vue&type=template&id=ec47a684"
import script from "./ProlongDialog.vue?vue&type=script&lang=js"
export * from "./ProlongDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports